import { RaceProgram } from "@tvg/ts-types/Race";
import { FiltersInlinePP } from "./types";
import { InlinePastPerformance } from "../../../../types";

export const getFilter =
  (activeFilter: FiltersInlinePP, currentRace: RaceProgram) =>
  (race: InlinePastPerformance) => {
    switch (activeFilter) {
      case FiltersInlinePP.TRACK:
        return race.track?.code === currentRace.track?.trackCode;
      case FiltersInlinePP.CONDITION:
        return (
          `${race.distance.value}${race.distance.code.toLowerCase()}` ===
            currentRace.distance &&
          race.surface.defaultCondition ===
            currentRace.surface?.defaultCondition &&
          race.surface.shortName === currentRace.surface.shortName
        );
      default:
        return true;
    }
  };

export const getFilteredRaces = (
  activeFilter: FiltersInlinePP,
  currentRace: RaceProgram,
  races: InlinePastPerformance[],
  maxResults: number = 5
) => races.filter(getFilter(activeFilter, currentRace)).slice(0, maxResults);

export const buildFitlerOptions = (trackName: string | undefined) => [
  { label: "Recent Races", value: FiltersInlinePP.RECENT },
  {
    label: trackName,
    value: FiltersInlinePP.TRACK
  },
  {
    label: "Match Today's Conditions",
    value: FiltersInlinePP.CONDITION
  }
];
